var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2203",
    "data-name": "Rettangolo 2203",
    width: 23,
    height: 24,
    transform: "translate(0.753 0.25)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2250",
    "data-name": "Raggruppa 2250",
    transform: "translate(-0.753 -0.25)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3599",
    "data-name": "Tracciato 3599",
    d: "M20.062,7.75c-.009,2.352,1.082,3.69,3.559,3.746-2.3-.009-3.442,1.29-3.559,3.746-.02-2.317-1.006-3.749-3.559-3.746C18.788,11.462,20.054,10.3,20.062,7.75Z",
    transform: "translate(-0.802 -0.008)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3600",
    "data-name": "Tracciato 3600",
    d: "M11.767,1c-.012,3.314,1.523,5.194,5.013,5.277-3.239-.013-4.849,1.816-5.013,5.276-.028-3.264-1.418-5.281-5.014-5.276C9.97,6.229,11.755,4.595,11.767,1Z",
    transform: "translate(-0.306 -0.001)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3601",
    "data-name": "Tracciato 3601",
    d: "M1.5,19.978v2.345a1.208,1.208,0,0,0,.327.828,1.09,1.09,0,0,0,.787.344H4.846",
    transform: "translate(-0.038 -0.022)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3602",
    "data-name": "Tracciato 3602",
    d: "M4.846,1H2.617a1.09,1.09,0,0,0-.787.344,1.208,1.208,0,0,0-.327.828V4.518",
    transform: "translate(-0.038 -0.001)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3603",
    "data-name": "Tracciato 3603",
    d: "M23.824,4.518V2.173a1.208,1.208,0,0,0-.327-.828A1.09,1.09,0,0,0,22.71,1H20.481",
    transform: "translate(-1.005 -0.001)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3604",
    "data-name": "Tracciato 3604",
    d: "M20.481,23.5H22.71a1.09,1.09,0,0,0,.787-.344,1.208,1.208,0,0,0,.327-.828V19.978",
    transform: "translate(-1.005 -0.022)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3605",
    "data-name": "Tracciato 3605",
    d: "M16.7,17.6a6.785,6.785,0,0,1-3.37,2.541,6.442,6.442,0,0,1-4.146-.006A6.788,6.788,0,0,1,5.82,17.59,7.366,7.366,0,0,1,4.5,13.453a7.216,7.216,0,0,1,1.129-3.9",
    transform: "translate(-0.191 -0.01)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleIcon);
export default __webpack_public_path__ + "static/media/style-icon.0925e8e4b81104273492759d369da423.svg";
export { ForwardRef as ReactComponent };